module.exports = __webpack_public_path__ + "static/img/manager-logo.157e156.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager-logo.png
// module id = +b2R
// module chunks = 2